var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-album-frentes-main"}},[_c('album-frentes',{attrs:{"idContrato":_vm.idContrato,"modulo":"ejecucion"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }